import styled from 'styled-components';

export const LogoWrapper = styled.div<{ $isBig: boolean }>`
  position: relative;
  rotate: -11.6deg;
  ${({ $isBig }) => $isBig && `zoom: 2.38;`};
`;

export const Logo = styled.div<{ $darkMode: boolean }>`
  width: 36px;
  height: 36px;
  background: url(${({ $darkMode }) => `/assets/images/logo${$darkMode ? '-dark' : ''}.svg`})
    center / contain no-repeat;
  position: relative;

  &::before {
    content: '';
    display: block;
    width: 105%;
    height: 105%;
    position: absolute;
    top: 3px;
    left: 0;
    background-color: ${({ $darkMode, theme }) => ($darkMode ? theme.custom?.background : '#FEF3EB')};
    border-radius: 12px;
    rotate: 18.9deg;
    z-index: -1;
  }
`;
